import React, {Component} from 'react'
import { Table, Dropdown } from 'semantic-ui-react'
import {isValueDupeInArray} from "./isValueDupeInArray";

class ColumnMatchRowLanding extends Component {
    changeColumnMap = (event, { value }) => {
        this.props.changeColumnMap(this.props.idx, value)
    }

    render() {
        return (
            <Table.Row>
                <Table.HeaderCell>{this.props.colName}</Table.HeaderCell>
                <Table.Cell>
                    <Dropdown options={this.props.dropdownOptions}
                              onChange={this.changeColumnMap}
                              selection
                              value={this.props.matchedColumn}
                              fluid />
                    {
                        this.props.matchedColumn !== null && isValueDupeInArray(this.props.matchedColumn, this.props.allMatchedColumns) ?
                            <small style={{color: 'red'}}>You can only map 1 column with the name</small> : null
                    }
                </Table.Cell>
            </Table.Row>
        )
    }
}

export default ColumnMatchRowLanding